function sea(code, phase, labelIt, labelEn, description, aliases, flags = {}, doklessCode = code) {
    return {
        code,
        mode: 'sea',
        phase,
        isFactCandidate: false,
        meansLoaded: false,
        meansDeparted: false,
        meansArrived: false,
        meansDischarged: false,
        meansClosed: false,
        ...flags,
        labelIt,
        labelEn,
        description,
        aliases,
        doklessCode,
    };
}
export const SEA_EVENT_CODES = [
    // ── Origin ──
    sea('booked', 'origin', 'prenotata', 'booked', 'The carrier accepted the booking; nothing physical exists yet.', ['BOOKED', 'BOOKING CONFIRMED', 'BOOKING ACCEPTED', 'Prenotazione confermata']),
    sea('empty_dispatched', 'origin', 'vuoto assegnato', 'empty dispatched', 'The empty container was assigned and released to the shipper.', ['EMPTY DISPATCHED', 'EMPTY RELEASED', 'CONTAINER RELEASE', 'EMPTY TO SHIPPER', 'Vuoto disponibile']),
    sea('empty_picked_up', 'origin', 'vuoto ritirato', 'empty picked up', 'The shipper picked up the empty container at the depot.', ['EMPTY PICKED UP', 'EMPTY GATE OUT', 'GATE OUT EMPTY', 'Ritiro vuoto']),
    sea('stuffed', 'origin', 'riempita', 'stuffed', 'The goods were loaded into the container.', [
        'STUFFED',
        'STUFFING',
        'CARGO RECEIVED',
        'LOADED AT FACILITY',
        'Riempimento',
    ]),
    sea('gate_in', 'origin', 'in terminal', 'gate in', 'The full container entered the terminal of the port of loading.', [
        'GATE IN',
        'GATE-IN',
        'GATEIN',
        'FULL GATE IN',
        'RECEIVED AT TERMINAL',
        'AT RAILWAY STATION',
        'Ingresso terminal',
    ], { isFactCandidate: true }),
    sea('customs_cleared_export', 'origin', 'sdoganata', 'export customs cleared', 'Export customs cleared the container.', ['EXPORT CLEARANCE', 'CUSTOMS RELEASE', 'Sdoganata']),
    sea('loaded_on_vessel', 'origin', 'imbarcata', 'loaded on vessel', 'The container was put on board.', ['LOADED', 'LOADED ON VESSEL', 'LOADED ON BOARD', 'ON BOARD', 'SHIPPED ON BOARD', 'Imbarcato'], { isFactCandidate: true, meansLoaded: true }),
    // ── Sea ──
    sea('vessel_departed', 'sea', 'in navigazione', 'vessel departed', 'The vessel left the port of loading.', ['DEPARTED', 'VESSEL DEPARTED', 'SAILED', 'DEPARTURE', 'ATD', 'Partita'], { isFactCandidate: true, meansDeparted: true }),
    sea('transshipment', 'sea', 'in trasbordo', 'transshipment', 'Change of vessel at an intermediate port (umbrella of ts_discharged/ts_loaded).', ['TRANSSHIPMENT', 'TRANSHIPMENT', 'T/S', 'TS', 'Trasbordo'], { isFactCandidate: true }),
    sea('ts_discharged', 'sea', 'a terra per trasbordo', 'discharged at transshipment', 'Discharged at the transshipment port, waiting for the next vessel.', ['DISCHARGED AT TRANSSHIPMENT', 'T/S DISCHARGE', 'TRANSSHIPMENT DISCHARGE'], { meansDischarged: true }, 'transshipment'),
    sea('ts_loaded', 'sea', 'reimbarcata', 'loaded at transshipment', 'Loaded on the next vessel after a transshipment.', ['LOADED AT TRANSSHIPMENT', 'T/S LOAD', 'TRANSSHIPMENT LOAD', 'RELOADED'], { meansLoaded: true }, 'transshipment'),
    sea('vessel_arrived', 'sea', 'nave arrivata', 'vessel arrived', 'The vessel arrived at the port of discharge; the container is still on board.', ['ARRIVED', 'VESSEL ARRIVED', 'ARRIVAL', 'ATA', 'BERTHED', 'Arrivata'], { isFactCandidate: true, meansArrived: true }),
    // ── Destination ──
    sea('discharged_from_vessel', 'destination', 'sbarcata', 'discharged from vessel', 'The container was discharged at the port of discharge.', ['DISCHARGED', 'DISCHARGED FROM VESSEL', 'UNLOADED', 'Sbarcato'], { isFactCandidate: true, meansDischarged: true }),
    sea('customs_cleared_import', 'destination', 'svincolata', 'import customs cleared', 'Import customs cleared the container.', ['IMPORT CLEARANCE', 'CUSTOMS CLEARED', 'CLEARED', 'Svincolata'], { meansClosed: true }),
    sea('available_for_pickup', 'destination', 'pronta al ritiro', 'available for pickup', 'The terminal released the container; free time starts counting.', ['AVAILABLE', 'READY FOR PICKUP', 'RELEASED', 'Disponibile al ritiro']),
    sea('gate_out', 'destination', 'uscita dal terminal', 'gate out', 'The full container left the terminal of destination.', ['GATE OUT', 'GATE-OUT', 'GATEOUT', 'FULL GATE OUT', 'Uscita terminal'], { isFactCandidate: true, meansClosed: true }),
    sea('delivered', 'destination', 'consegnata', 'delivered', 'Delivered to the consignee.', ['DELIVERED', 'DELIVERY', 'Consegnato'], { isFactCandidate: true, meansClosed: true }),
    sea('empty_returned', 'destination', 'vuoto reso', 'empty returned', 'The empty container went back to the depot.', ['EMPTY RETURNED', 'EMPTY RETURN', 'CONTAINER RETURN', 'EMPTY IN', 'Reso vuoto'], { isFactCandidate: true, meansClosed: true }),
    // ── Problems ──
    sea('rolled_over', 'problem', 'lasciata a terra', 'rolled over', 'The vessel left without the container; it goes with the next one.', ['ROLLED', 'ROLL OVER', 'ROLLOVER', 'SHUT OUT', 'NOT SHIPPED', 'Rullato']),
    sea('delayed', 'problem', 'in ritardo', 'delayed', 'The carrier declared a delay or moved a date forward.', ['DELAYED', 'DELAY', 'RESCHEDULED', 'ETA CHANGED', 'Ritardo']),
    sea('held', 'problem', 'ferma', 'held', 'Held by customs, health authority, unpaid charges or inspection.', ['HOLD', 'ON HOLD', 'CUSTOMS HOLD', 'BLOCKED', 'DETAINED', 'Fermo']),
    sea('inspection', 'problem', 'in ispezione', 'inspection', 'Selected for physical or scanner inspection.', [
        'INSPECTION',
        'EXAM',
        'SCANNING',
        'X-RAY',
        'Verifica',
    ]),
    sea('demurrage_started', 'problem', 'controstallie', 'demurrage started', 'Free time at the port is over: demurrage accrues daily.', ['DEMURRAGE', 'STORAGE STARTED', 'Controstallie']),
    sea('detention_started', 'problem', 'detention', 'detention started', 'Free time to return the empty is over: detention accrues daily.', ['DETENTION', 'Sosta container']),
    sea('damaged', 'problem', 'danneggiata', 'damaged', 'Container or goods damaged.', [
        'DAMAGED',
        'DAMAGE REPORTED',
        'Danneggiato',
    ]),
    sea('canceled', 'problem', 'annullata', 'canceled', 'The booking was canceled.', [
        'CANCELLED',
        'CANCELED',
        'VOID',
        'Annullata',
    ]),
    // ── Fallback ──
    sea('unknown', null, 'sconosciuto', 'unknown', 'An event the reader could not map to a known code.', []),
];
function air(code, phase, labelIt, labelEn, description, flags = {}) {
    return { ...sea(code, phase, labelIt, labelEn, description, [], flags), mode: 'air' };
}
/**
 * The reserved air codes (02 §1.1, Cargo-IMP style), not implemented in v2.0.
 * `booked` and `delivered` are the shared codes above; these are air's own.
 */
export const AIR_EVENT_CODES = [
    air('received_from_shipper', 'origin', 'ricevuta dal mittente', 'received from shipper', 'The airline or its handler received the goods from the shipper (RCS).'),
    air('manifested', 'origin', 'manifestata', 'manifested', 'The goods are on the flight manifest (MAN).', {
        meansLoaded: true,
    }),
    air('departed', 'sea', 'partita', 'departed', 'The flight left (DEP).', { meansDeparted: true }),
    air('transferred', 'sea', 'trasferita', 'transferred', 'The goods were transferred to another flight at a hub (TFD).'),
    air('arrived', 'sea', 'arrivata', 'arrived', 'The flight arrived (ARR).', { meansArrived: true }),
];
/** The codes shared by sea and air (one row each, `mode` = the mode that introduced them). */
export const SHARED_EVENT_CODES = ['booked', 'delivered'];
export const EVENT_CATALOGUE = [...SEA_EVENT_CODES, ...AIR_EVENT_CODES];
//# sourceMappingURL=event-codes.js.map